import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath, Modal } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';
import togglePageLock from '../utils/togglePageLock';
import hideTheHouse from '../utils/hideTheHouse';

const componentClass = 'modalPage';

const ModalPageContainer = ({ className, children, id, isActive, modalClassName, nodeId, onClose, onCloseTimeout, onBackButtonClick, shouldCenterContent }) => {
    const [isReadyToClose, setIsReadyToClose] = useState(false);
    const classes = classnames(componentClass, className, {
        [`${componentClass}--isClosing`]: isReadyToClose
    });
    const modalClasses = classnames(`${componentClass}__modal`, modalClassName, {
        centeredModalPage: shouldCenterContent
    });

    const onReadyToClose = () => {
        setIsReadyToClose(true);
        hideTheHouse(false);
        setTimeout(() => {
            onClose && onClose();
            setIsReadyToClose(false);
        }, onCloseTimeout || 1000);
    };

    const closeButton = <div className={`${componentClass}__close-button animated`} onClick={onReadyToClose}>
        <ReactSVG src={ getPublicImagePath('close-icon.svg') } />
    </div>;

    const backButton = <div className={`${componentClass}__back-button animated fadeIn`} onClick={onBackButtonClick}>
        <ReactSVG src={ getPublicImagePath('back-arrow-icon.svg') } />
    </div>;

    useEffect(() => {
        if (isActive) {
            togglePageLock(true);
            hideTheHouse(true);
        } else {
            togglePageLock(false);
            hideTheHouse(false);
        }

        return () => {
            togglePageLock(false);
            hideTheHouse(false);
        }
    }, [isActive]);

    return <div className={classes} id={id}>
        { (isActive && onBackButtonClick) && backButton }
        { isActive && closeButton }
        <Modal show={isActive} onClose={onClose} closeOnOuterClick={false} className={modalClasses} nodeId={nodeId}>
            { children }
        </Modal>
    </div>;
};

ModalPageContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    isActive: PropTypes.bool.isRequired,
    modalClassName: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onBackButtonClick: PropTypes.func
};

export default ModalPageContainer;
